import React from 'react';
import { Package, Settings, Info } from 'lucide-react';

interface BusinessSettingsCardProps {
  businessSettings: {
    sacos_por_palete: number;
    peso_por_saco: number;
    km_max_route: number;
    media_sacos_por_order: number;
  };
  onBusinessSettingsChange: (field: string, value: number) => void;
}

export const BusinessSettingsCard: React.FC<BusinessSettingsCardProps> = ({
  businessSettings,
  onBusinessSettingsChange
}) => {
  return (
    <div
      className="rounded-xl shadow-lg border p-6"
      style={{
        backgroundColor: 'var(--bg-card)',
        borderColor: 'var(--border-primary)'
      }}
    >
      <div className="flex items-center gap-3 mb-6">
        <div className="p-2 bg-green-100 rounded-lg">
          <Package className="w-6 h-6 text-green-600" />
        </div>
        <div>
          <h2
            className="text-xl font-semibold"
            style={{ color: 'var(--text-primary)' }}
          >
            Configurações de Negócio
          </h2>
          <p
            className="text-sm"
            style={{ color: 'var(--text-secondary)' }}
          >
            Configure os parâmetros específicos do seu negócio
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Sacos por Palete */}
        <div className="space-y-2">
          <label
            className="block text-sm font-medium"
            style={{ color: 'var(--text-primary)' }}
          >
            Sacos por Palete
          </label>
          <input
            type="number"
            value={businessSettings.sacos_por_palete || ""}
            onChange={(e) => onBusinessSettingsChange('sacos_por_palete', parseInt(e.target.value) || 0)}
            className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
            style={{
              backgroundColor: 'var(--bg-card)',
              borderColor: 'var(--border-primary)',
              color: 'var(--text-primary)'
            }}
            min="1"
            max="200"
          />
          <p
            className="text-xs"
            style={{ color: 'var(--text-secondary)' }}
          >
            Quantidade padrão de sacos por palete
          </p>
        </div>

        {/* Peso por Saco */}
        <div className="space-y-2">
          <label
            className="block text-sm font-medium"
            style={{ color: 'var(--text-primary)' }}
          >
            Peso por Saco (kg)
          </label>
          <input
            type="number"
            value={businessSettings.peso_por_saco || ""}
            onChange={(e) => onBusinessSettingsChange('peso_por_saco', parseInt(e.target.value) || 0)}
            className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
            style={{
              backgroundColor: 'var(--bg-card)',
              borderColor: 'var(--border-primary)',
              color: 'var(--text-primary)'
            }}
            min="1"
            max="100"
          />
          <p
            className="text-xs"
            style={{ color: 'var(--text-secondary)' }}
          >
            Peso médio de cada saco em quilogramas
          </p>
        </div>

        {/* KM Máximo da Rota */}
        <div className="space-y-2">
          <label
            className="block text-sm font-medium"
            style={{ color: 'var(--text-primary)' }}
          >
            KM Máximo da Rota
          </label>
          <input
            type="number"
            value={businessSettings.km_max_route || ""}
            onChange={(e) => onBusinessSettingsChange('km_max_route', parseInt(e.target.value) || 0)}
            className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
            style={{
              backgroundColor: 'var(--bg-card)',
              borderColor: 'var(--border-primary)',
              color: 'var(--text-primary)'
            }}
            min="100"
            max="10000"
          />
          <p
            className="text-xs"
            style={{ color: 'var(--text-secondary)' }}
          >
            Distância máxima permitida para rotas
          </p>
        </div>

        {/* Média de Sacos por Pedido */}
        <div className="space-y-2">
          <label
            className="block text-sm font-medium"
            style={{ color: 'var(--text-primary)' }}
          >
            Média de Sacos por Pedido
          </label>
          <input
            type="number"
            value={businessSettings.media_sacos_por_order || ""}
            onChange={(e) => onBusinessSettingsChange('media_sacos_por_order', parseInt(e.target.value) || 0)}
            className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
            style={{
              backgroundColor: 'var(--bg-card)',
              borderColor: 'var(--border-primary)',
              color: 'var(--text-primary)'
            }}
            min="1"
            max="10000"
          />
          <p
            className="text-xs"
            style={{ color: 'var(--text-secondary)' }}
          >
            Quantidade média de sacos por pedido
          </p>
        </div>
      </div>

      <div className="mt-4 p-3 rounded-md" style={{ backgroundColor: 'var(--bg-secondary)' }}>
        <div className="flex items-center gap-2 mb-2">
          <Info className="h-4 w-4" style={{ color: 'var(--text-primary)' }} />
          <span className="text-sm font-medium" style={{ color: 'var(--text-primary)' }}>
            Informações Importantes
          </span>
        </div>
        <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>
          Essas configurações são utilizadas para cálculos de frete, planejamento de rotas e análises de eficiência logística.
        </p>
      </div>
    </div>
  );
};
